export const READ_PRIVILEGES_PRIVILEGE = 'READ_PRIVILEGES_PRIVILEGE';

export const ROLE_PRIVILEGES = {
  CREATE: 'CREATE_ROLES_PRIVILEGE',
  READ: 'READ_ROLES_PRIVILEGE',
  UPDATE: 'UPDATE_ROLES_PRIVILEGE',
  DELETE: 'DELETE_ROLES_PRIVILEGE',
};

export const USER_PRIVILEGES = {
  CREATE: 'CREATE_USERS_PRIVILEGE',
  READ: 'READ_USERS_PRIVILEGE',
  UPDATE: 'UPDATE_USERS_PRIVILEGE',
  DELETE: 'DELETE_USERS_PRIVILEGE',
  BLOCK: 'BLOCK_USERS_PRIVILEGE',
  UNBLOCK: 'UNBLOCK_USERS_PRIVILEGE',
};

export const TEST_PRIVILEGES = {
  CREATE: 'CREATE_TESTS_PRIVILEGE',
  READ: 'READ_TESTS_PRIVILEGE',
  UPDATE: 'UPDATE_TESTS_PRIVILEGE',
  DELETE: 'DELETE_TESTS_PRIVILEGE',
  ACTIVATE: 'ACTIVATE_TESTS_PRIVILEGE',
  DEACTIVATE: 'DEACTIVATE_TESTS_PRIVILEGE',
};

export const TEST_RESULT_PRIVILEGES = {
  READ: 'READ_TEST_RESULTS_PRIVILEGE',
  UPDATE: 'UPDATE_TEST_RESULTS_PRIVILEGE',
  DELETE: 'DELETE_TEST_RESULTS_PRIVILEGE',
  COMMIT: 'COMMIT_TEST_RESULTS_PRIVILEGE',
  CANCEL: 'CANCEL_TEST_RESULTS_PRIVILEGE',
};
